<template>
  <div class="modal_dim on"><!--'on 추가'-->
    <div class="modal_wrap">
      <div class="modal_inner center w1200">
        <div class="modal">
          <div class="modal_con">
            <div class="modal_txt" style="padding: 60px;">
              <p v-html="data.message">
              </p>
            </div>
          </div>
          <div class="modal_btn">
            <div class="btn_wrap">
              <button class="btn" @click="fnYes(data)">예</button>
              <button class="btn bo grey" @click="fnNo(data)">아니오</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-common-confim-info',
  description: '회원 찾기 결과 모달',
  props: {
    data: {
      type: [Array, Object],
      default: () => {}
    },
    callBack: {
      type: [Function]
    }
  },
  methods: {
    fnYes: function(data) {
      console.log('fnYes')
      if(data.type === 'findUserResult') {
        // 아이디 찾기 & 비밀번호 찾기
        // 회원가입 페이지로 이동
        this.$router.push({ path: '/sign/up/step1' })
      }

      if(data.type === 'changeUserStatus'){
        // 휴면 해제하기 팝업
        this.$store.commit('layout/setModalAlert', { data: {  }, modalAlertName: this.$modalAlertNames.MODAL_CHANGE_USER_INACTIVE })
      }

      // 동시 로그인 방지
      if(data.type === 'checkLoginSession'){
        // 로그인
        const params = {}
        params.userId = data.itemList.userId
        params.userPw = data.itemList.userPw
        params.applicationId = 'site'

        this.$SignSvc.login(params).then(res => {
              if(res.code === 1) {
                if (this.$router.currentRoute.path === '/main') {
                  this.$router.go(this.$router.currentRoute)
                } else {
                  this.$router.push({path: '/main'})
                }
              }
            })
      }
    },
    fnNo: function(data) {
      console.log('fnNo')
      if(data.type === 'findUserResult'){
        // 메인으로 이동
        this.$router.push({ path: '/main' })
      }

      if(data.type === 'changeUserStatus' || data.type === 'checkLoginSession'){
        // 팝업 닫기
        this.$emit('eventClose')
      }
    }
  }
}
</script>

<style scoped>

</style>
